import { useEffect } from 'react';

import { usePlayerStore } from '@cartwhl/3d/player';

import {
  registerMotionEditorVideoRecorder,
} from '../videoExport/motionEditorVideoExportStore';
import { useMotionEditorCanvasRecorder } from '../videoExport/useMotionEditorCanvasRecorder';

/** Registers canvas FFmpeg capture with the motion-editor video export store (must render inside Player.Canvas). */
export default function MotionEditorVideoRecorderBridge() {
  const store = usePlayerStore();
  const canvasRecorder = useMotionEditorCanvasRecorder(store);

  useEffect(() => {
    registerMotionEditorVideoRecorder(canvasRecorder);
    return () => {
      registerMotionEditorVideoRecorder(null);
    };
  }, [canvasRecorder]);

  return null;
}
